/* Andrius Užkalnis theme */
(function () {
  'use strict';

  /* ---- light / dark ---- */
  var btn = document.getElementById('themeBtn');
  if (btn) {
    btn.addEventListener('click', function () {
      var el = document.documentElement;
      var next = el.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      el.setAttribute('data-theme', next);
      try { localStorage.setItem('uz-theme', next); } catch (e) {}
    });
  }

  /* ---- mobile menu ---- */
  var menuBtn = document.getElementById('menuBtn');
  var nav = document.getElementById('nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', open);
    });
  }

  /* ---- announcement bar memory ---- */
  var ann = document.getElementById('announce');
  if (ann) {
    try { if (localStorage.getItem('uz-announce') === 'off') ann.remove(); } catch (e) {}
    var x = ann.querySelector('.x');
    if (x) x.addEventListener('click', function () { try { localStorage.setItem('uz-announce', 'off'); } catch (e) {} });
  }
})();


/* ---- QR welcome modal (once per visitor) ---- */
(function(){
  var m=document.getElementById('qrModal'); if(!m) return;
  var seen=false;
  try { seen = localStorage.getItem('uz-qr') === 'seen'; } catch(e){}
  if(seen) { m.remove(); return; }
  function close(){
    m.classList.remove('on');
    setTimeout(function(){ m.setAttribute('hidden',''); }, 240);
    try { localStorage.setItem('uz-qr','seen'); } catch(e){}
  }
  m.removeAttribute('hidden');
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ m.classList.add('on'); }); });
  var x=document.getElementById('qrX'), no=document.getElementById('qrNo'), go=document.getElementById('qrGo');
  if(x) x.addEventListener('click', close);
  if(no) no.addEventListener('click', close);
  if(go) go.addEventListener('click', function(){ try{localStorage.setItem('uz-qr','seen');}catch(e){} });
  m.addEventListener('click', function(e){ if(e.target===m) close(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
})();

/* ---- autograph choice: inscription is the default, opting out is deliberate ---- */
function uzPick(i){
  var v0=document.getElementById('v0'), v1=document.getElementById('v1');
  if(v0) v0.classList.toggle('on', i===0);
  if(v1) v1.classList.toggle('on', i===1);
  var el = i===1 ? v1 : v0;
  if(!el) return;
  var hid=document.getElementById('VariantId');
  if(hid) hid.value = el.getAttribute('data-vid');
  var note=document.getElementById('bbNote');
  if(note) note.textContent = el.getAttribute('data-nm');
  var ins=document.getElementById('Inscription');
  if(ins){
    ins.classList.toggle('on', i===1);
    if(i!==1){
      var fs=ins.querySelectorAll('input');
      for(var k=0;k<fs.length;k++) fs[k].value='';
    }
  }
}

/* Andrius: people forget the inscription, so a signed book with no "kam" is blocked. */
(function(){
  var form=document.getElementById('ProductForm'); if(!form) return;
  form.addEventListener('submit', function(e){
    var v1=document.getElementById('v1');
    var signed = v1 && v1.classList.contains('on');
    var to=document.getElementById('ToWhom');
    var hint=document.getElementById('uzInsHint');
    if(signed && to && !to.value.trim()){
      e.preventDefault();
      if(hint){
        hint.textContent='Parašykite, kam užrašyti — arba pasirinkite „Autografo nereikia“.';
        hint.style.color='var(--accent)';
      }
      to.focus();
      return false;
    }
  });
})();
